var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseArrowSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.799 489.799",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.141,338.154L349.76,206.773l86.029-47.447c7.66-4.225,12.027-12.646,11.078-21.355 c-0.953-8.707-7.049-15.982-15.438-18.449L27.839,0.883c-7.627-2.24-15.852-0.145-21.467,5.469 c-5.609,5.613-7.707,13.838-5.463,21.467l118.607,403.605c2.465,8.402,9.756,14.498,18.449,15.449 c8.707,0.955,17.127-3.418,21.352-11.078l47.436-86.014l131.381,131.383c11.512,11.514,30.158,11.514,41.672,0l101.336-101.336 C492.653,368.314,492.653,349.67,481.141,338.154z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseArrowSvgrepoCom);
export default __webpack_public_path__ + "static/media/mouse-arrow-svgrepo-com.1990ebc278437b7c0111721352f6d1c8.svg";
export { ForwardRef as ReactComponent };